import { InputSwitch } from "primereact/inputswitch";
import localeText from "../../../../../locale";
import FormField from "../../../components/form/FormField";
import { DEVICES, LANGS, countImages, slotField } from "../bannerModel";
import BannerSlot from "./BannerSlot";

// Um banner do carrossel: visibilidade, link de destino e as 8 imagens (desktop/mobile x idioma)
const BannerCard = ({ banner, index, ratio, onChange, onPickImage, onRemove, onInvalidImage }) => {
  const filled = countImages(banner);

  return (
    <section className="admin-banner-card">
      <header className="admin-banner-card__header">
        <div className="admin-banner-card__title-group">
          <h3 className="admin-banner-card__title">Banner {index + 1}</h3>
          <span className="admin-muted">
            {filled}/8 {localeText("adminBannersImages")}
          </span>
        </div>
        <label className="admin-banner-card__toggle">
          <InputSwitch
            checked={banner.showImage}
            onChange={(e) => onChange({ showImage: e.value })}
            aria-label={localeText("showBanner")}
          />
          <span>{localeText(banner.showImage ? "adminBannersVisible" : "adminBannersHidden")}</span>
        </label>
        {!banner.primary && (
          <button
            type="button"
            className="admin-icon-btn admin-btn--danger-hover"
            onClick={onRemove}
            title={localeText("removeBanner")}
            aria-label={`${localeText("removeBanner")} ${index + 1}`}
          >
            <i className="pi pi-trash" aria-hidden="true" />
          </button>
        )}
      </header>

      <div className="admin-banner-card__grid">
        <span />
        {LANGS.map((lang) => (
          <span key={lang.code} className="admin-banner-card__col-label">
            {lang.code.toUpperCase()}
          </span>
        ))}
        {DEVICES.map((device) => (
          <div key={device.key} className="admin-banner-card__row">
            <span className="admin-banner-card__row-label">
              <i
                className={device.key === "desktop" ? "pi pi-desktop" : "pi pi-mobile"}
                aria-hidden="true"
              />
              {localeText(device.key === "desktop" ? "adminBannersDesktop" : "adminBannersMobile")}
            </span>
            {LANGS.map((lang) => {
              const field = slotField(device.key, lang.code);
              return (
                <BannerSlot
                  key={field}
                  label={lang.code.toUpperCase()}
                  value={banner.images[field]}
                  ratio={ratio}
                  onPick={(file) => onPickImage(field, file)}
                  onInvalid={onInvalidImage}
                />
              );
            })}
          </div>
        ))}
      </div>

      <FormField label={localeText("urlToRedirect")} htmlFor={`${banner.key}-url`}>
        <input
          id={`${banner.key}-url`}
          className="admin-input"
          value={banner.urlDestination}
          onChange={(e) => onChange({ urlDestination: e.target.value })}
          placeholder="https://"
          autoComplete="off"
          inputMode="url"
        />
      </FormField>
    </section>
  );
};

export default BannerCard;
